module.exports = __webpack_public_path__ + "static/media/УОМШ-26 - 1_260927_144021.13a75a27.pdf";